<template>
	<v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame">
		<div class="container-box">
			<!-- 顶部 -->
			<div class="header">
				<tabBarNew class="tabBarStyle"></tabBarNew>
				
			</div>
			<div class="newsTitleFrame" style="margin-top: 7.5vh;">
			  <div class="journalismTitle">
			    <div class="journalismChild">
			      <span>旗舰店铺</span>
			    </div>
			  </div>
			</div>
			<!-- 内容 -->
			<div class="content" style="display: flex; flex-direction: row; padding-left: 10px; padding-right: 10px;">
				<div ><img style="width: 100%;" src="../../assets/dianpu.png" /></div>
			</div>
			<div class="newsTitleFrame">
			  <div class="journalismTitle">
			    <div class="journalismChild">
			      <span>产品展示</span>
			    </div>
			  </div>
			</div>
			<!-- 内容 -->
			<div class="content" style="display: flex; flex-direction: row; padding-left: 10px; padding-right: 10px;">
				<div style="margin-right: 10px;"><img src="../../assets/big1.jpg" style="height: 100%; width: 100%;" /></div>
				<div><img src="../../assets/big2.jpg" style="height: 100%; width: 100%; " /></div>
			</div>
			<div class="newsTitleFrame" style="margin-top: 0;">
			  <div class="journalismTitle">
			    <div class="journalismChild">
			      <span>产品展示</span>
			    </div>
			  </div>
			</div>
			<div style="display: flex; flex-direction: row; margin-top: 15px; padding-left: 10px; padding-right: 10px; width: 100%;">
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm1.png" style="height: 100%; width: 100%;" /></div>
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm2.jpg" style="height: 100%; width: 100%;" /></div>
				<div style="width: 33%;"><img src="../../assets/sm3.jpg" style="height: 100%; width: 100%; " /></div>
			</div>
			<div style="display: flex; flex-direction: row; margin-top: 15px; padding-left: 10px; padding-right: 10px;">
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm4.jpg" style="height: 100%; width: 100%;" /></div>
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm5.png" style="height: 100%; width: 100%;" /></div>
				<div style="width: 33%;"><img src="../../assets/sm6.png" style="height: 100%; width: 100%; " /></div>
			</div>
			<div style="display: flex; flex-direction: row; margin-top: 15px; padding-left: 10px; padding-right: 10px;">
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm7.png" style="height: 100%; width: 100%;" /></div>
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm8.jpg" style="height: 100%; width: 100%;" /></div>
				<div style="width: 33%;"><img src="../../assets/sm9.png" style="height: 100%; width: 100%; " /></div>
			</div>
			<div style="display: flex; flex-direction: row; margin-top: 15px; padding-left: 10px; padding-right: 10px; margin-bottom: 20px;">
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm10.png" style="height: 100%; width: 100%;" /></div>
				<div style="margin-right: 15px; width: 33%;"><img src="../../assets/sm11.jpg" style="height: 100%; width: 100%;" /></div>
				<div style="width: 33%;"><img src="../../assets/sm12.png" style="height: 100%; width: 100%; " /></div>
			</div>
			<fixedBottomRight></fixedBottomRight>
		</div>
	</v-touch>
</template>

<script>
	import tabBarNew from "../../assembly/tabBarNew.vue";
	import swiper from "../../assembly/mobileSwiper.vue";
	import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
	export default {
		name: "introduce",
		data() {
			return {
				tabBarTitle: "",
				tabBarTitle1: "",
				introduceFont: `\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩数智科技有限公司（简称“山哩数智”）成立于2022年5月，是一家专注于个贷不良资产智能化运营的科技创新型企业。公司以“数智科技+大数据”为双引擎，为个贷不良资产提供全产业链管理服务。
公司自主研发的“E法通”智能系统，基于S2B2C案源供应链模式，集资产评估、智能分案与司法调解于一体，构建了覆盖全流程的数字化解决方案。
作为山哩控股集团的核心业务主体，山哩数智已完成全国化战略布局，控股河北、湖南、安徽、陕西、河南、江苏、广西等多家区域子公司，形成覆盖全国的规模化运营网络。`,
				enterpriseVision: "引领新消费、新经济、新业态;让中国新经济产业走向世界",
				governmentFont: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩科技的快速成长, 离不开党和国家的各项优惠政策, 更离不开各级政府领导的亲切关怀。公司成立以来各级政府领导多次对公司进行业务指导, 并对山哩科技的发展给予高度的肯定和赞赏, 鼓舞着山哩人乘风破浪勇往直前",
				list: [{
						url: require("@/assets/deve1.png"),
						title: "2013",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目以京东合伙人, 阿里生鲜、京东生鲜供应商的形式落地贵州毕节黔西。"
					},
					{
						url: require("@/assets/deve2.png"),
						title: "2014",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0京东生鲜正式纳入贵州项目, 正式启动京东黔西县特产馆。"
					},
					{
						url: require("@/assets/deve3.png"),
						title: "2015",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目成功获得西南地区阿里、京东生鲜的唯一供应商。"
					},
					{
						url: require("@/assets/deve4.png"),
						title: "2016",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0正式与黔西县人民政府签署战略合作, 成立好农哥生态农业有限公司"
					},
					{
						url: require("@/assets/deve5.png"),
						title: "2017",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名"
					},
					{
						url: require("@/assets/deve6.png"),
						title: "2018",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa02018年7月山哩优品电商品牌正式与京东脱离"
					},
					{
						url: require("@/assets/deve7.png"),
						title: "2019",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0独立运营, 寻求合作伙伴, 以最佳的现货交易模式做全国顶尖的订单农业电商品牌"
					},
					{
						url: require("@/assets/deve8.png"),
						title: "2020",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0通过VIE架构在美国纳斯达克上市。山哩成为该年度以SPAC主板上市企业"
					},
					{
						url: require("@/assets/deve9.png"),
						title: "2021",
						content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0完成了A轮的3亿元人民币融资, 开启了向纳斯达克主板上市之路"
					}
				]
			};
		},
		components: {
			tabBarNew,
			swiper,
			fixedBottomRight
		},
		methods: {
			swiperleft() {
				/* this.$router.push({
					name: 'cooperation'
				}) */
			},
			swiperight() {
				/* this.$router.push({
					name: 'index'
				}) */
			},
			clickImg() {
				window.location.href = "https://mbd.baidu.com/newspage/data/videolanding?nid=sv_14798706679523612252"
			}
		}
	};
</script>

<style lang="scss" scoped>
	.frame {
		position: absolute;
		height: 100%;
		width: 100%;
		touch-action: pan-y !important;
	}

	.container-box {
		display: flex;
		flex-direction: column;

		.imgStyle {
			height: 100%;
			width: 100%;
		}

		.header {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			position: fixed;
			background-color: #fff;
			height: 7.5vh;
			width: 100%;
			z-index: 999;

			.headerChild {
				height: 59%;
				width: 100vw;
			}

			.tabBarFontFrame {
				pointer-events: none;
				color: #fff;
				height: 5vh;
				width: 100%;
				position: absolute;
				top: 24vh;
				z-index: 3;
				display: flex;
				align-items: center;
				flex-direction: column;

				.tabBarFont {
					letter-spacing: 2px;
					font-weight: bold;
					font-size: 1.3rem;
				}

				.tabBarFont1 {
					margin-top: 2%;
					font-size: 1rem;
					letter-spacing: 2px;
				}
			}
		}

		.content {
			width: 100vw;

			// 企业介绍
			.introduceContent {
				display: flex;
				flex-direction: column;

				.introduceContentImg {
					height: 25vh;
					margin: 1rem;
					margin-bottom: 10px;
				}

				.introduceContentTitle {
					height: 1.6vh;
					display: flex;
					flex-direction: column;
					justify-content: center;
					padding: 1rem 1.5rem;
					margin-left: 1rem;
					border-left: #7b0000 solid 10px;

					.contentFont {
						font-size: 1.5rem;
						font-weight: bold;
					}

					.contentFont1 {
						letter-spacing: 1px;
						font-size: 0.8rem;
					}
				}

				.introduceContentContent {
					margin: 1rem;
					font-size: 0.85rem;
					letter-spacing: 1px;
					font-weight: bold;
					display: flex;
					flex-wrap: wrap;
				}
			}

			// 企业发展历程
			.developFrame {
				display: flex;
				flex-direction: column;

				.developFrameContent {
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 100%;

					// 插入
					.insertFrame {
						margin-top: 1rem;
						position: absolute;
						display: flex;
						justify-content: center;
						margin-left: 1rem;
						width: 60%;
					}

					.insertChildFrame {
						width: 0.3rem;
						background-color: #7b0000;
					}

					.circleGroup {
						left: -0.63rem;
						position: relative;
						display: flex;
						flex-direction: column;

						.circle {
							width: 1rem;
							height: 1rem;
							background-color: #7b0000;
							border-radius: 20px;
							margin-top: 19.4rem;
						}
					}

					.developLoopFrame {
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;
						width: 96%;

						// 循环
						.developLoop {
							margin: 1rem 0.1rem;
							padding: 0.2rem;
							overflow: hidden;
							width: 45%;
							background-color: #cfcccc;

							.developLoopImg {
								height: 50%;
								margin: 0.4rem;
							}

							.developLoopTitle {
								margin-left: 0.5rem;
								font-weight: bold;
								font-size: 1.5rem;
								color: #7b0000;
							}

							.developLoopContent {
								margin-left: 0.5rem;
								font-size: 0.8rem;
								color: black;
								font-weight: bold;
							}
						}

						// 文字
						.propaganda {
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							width: 40%;

							.propagandaChild {
								height: 50%;

								.propagandaChild1 {
									font-size: 2rem;
									font-weight: bold;
								}

								.propagandaChild2 {
									font-size: 1.2rem;
								}

								.propagandaChild3 {
									font-size: 1.2rem;
									font-weight: bold;
								}
							}
						}
					}
				}
			}

			// 企业文化
			.corporateCulture {
				display: flex;
				flex-direction: column;
				width: 100%;

				.corporateCultureContent {
					width: 100%;
					height: 40vh;

					.corporateCultureContentImg {
						height: 60%;
						width: 100%;
					}

					.corporateCultureContentImg1 {
						display: flex;
						flex-direction: column;
						align-items: center;
						height: 54%;

						//  企业愿景
						.enterpriseVisionFrame {
							height: 14vh;
							width: 100%;
							position: absolute;
							z-index: 3;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							color: #fff;

							.cultureFont {
								font-size: 1.2rem;
								font-weight: bold;
								letter-spacing: 2px;
							}

							.cultureFont1 {
								margin-top: 0.2rem;
								font-size: 0.5rem;
							}
						}

						.cultureChild {
							top: 1rem;
							position: relative;
							height: 65%;
							width: 90%;
						}

						.cultureChild1 {
							height: 35%;
							width: 100%;
							background-color: rgb(179, 108, 108);
						}
					}
				}
			}

			// 企业资质
			.qualifications {
				.qualificationsContent {
					display: flex;
					flex-direction: column;

					.responsibility {
						display: flex;
						flex-direction: column;

						.responsibilityTitle {
							margin-left: 1rem;
							padding-left: 0.5rem;
							border-left: 2px solid #7b0000;
							letter-spacing: 1.5px;
							font-size: 1.2rem;
						}

						.responsibilityImg {
							margin: 1rem 0.2rem;
							height: 22vh;
						}
					}

					.governmentCare {
						display: flex;
						flex-direction: column;

						.governmentCareTitle {
							margin-left: 1rem;
							padding-left: 0.5rem;
							border-left: 2px solid #7b0000;
							letter-spacing: 1.5px;
							font-size: 1.2rem;
						}

						.governmentCareContent {
							height: 30vh;

							.governmentCareContentImg {
								top: 1rem;
								position: relative;
								margin: 0 0.3rem;
								display: flex;
								justify-content: space-between;
								height: 18vh;

								.governmentCareContentImgChild {
									height: 90%;
									width: 60%;
								}

								.governmentCareContentImgChild1 {
									height: 90%;
									width: 40%;
								}
							}

							.governmentCareContentBg {
								display: flex;
								justify-content: center;
								align-items: center;
								height: 50%;
								width: 100%;
								background-color: #7b0000;
								color: #fff;
								font-size: 0.9rem;

								.governmentCareContentFont {
									height: 50%;
									width: 90%;
								}
							}
						}
					}
				}
			}
		}

		.IntroduceTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 10vh;

			.IntroduceTitleBg {
				height: 65%;
				width: 30%;
				background-color: rgb(179, 108, 108);
			}

			.IntroduceTitleFont {
				z-index: 3;
				position: absolute;
				display: flex;
				flex-direction: column;
				align-items: center;
				color: #7b0000;
				flex-wrap: nowrap;
				display: flex;
				width: 100%;

				.IntroduceTitleFontChild {
					font-weight: bold;
					font-size: 1.3rem;
				}

				.IntroduceTitleFontChild1 {
					font-size: 0.5rem;
				}
			}
		}
	}
	.newsTitleFrame {
	  width: 100%;
	  background-color: #fff;
	
	  .journalismTitle {
	    display: flex;
	    flex-direction: column;
	    justify-content: center;
	    padding: 1.5rem 0.5rem;
	    border-bottom: solid 2px gray;
	    width: 98%;
	    margin-left: 0.5rem;
	    margin-bottom: 0.5rem;
	
	    .journalismChild {
	      height: 2rem;
	      border-left: solid 6px #7b0000;
	      font-weight: bold;
	      padding-left: 0.6rem;
	      padding-bottom: 1.2rem;
	      letter-spacing: 0.2rem;
	    }
	  }
	}
</style>


// WEBPACK FOOTER //
// src/components/iphone/productCenter.vue